/**
 * Mã màn hình
 */
export default {
  Login: 'login',
  BUTransfer: 'BUTransfer',
};
